export default __webpack_public_path__ + "static/envelopeTopInside-9214de5f1ddb7d41040d2e49717f05ba.png";